module.exports = __webpack_public_path__ + "img/HC1006-74.3aa095ec.jpg";